import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { injectedConnector } from "../utils/connectors";
import { addConnectEvent } from "../utils/analytics";
var useEagerConnect = function () {
    var _a = useWeb3React(), activate = _a.activate, active = _a.active, account = _a.account;
    var _b = useState(false), tried = _b[0], setTried = _b[1];
    useEffect(function () {
        if (tried) {
            return;
        }
        injectedConnector.isAuthorized().then(function (isAuthorized) {
            if (isAuthorized) {
                activate(injectedConnector, undefined, true).catch(function () {
                    setTried(true);
                });
            }
            else {
                setTried(true);
            }
        });
    }, [activate, tried]); // intentionally only running on mount (make sure it's only mounted once :))
    // if the connection worked, wait until we get confirmation of that to flip the flag
    useEffect(function () {
        if (!tried && active) {
            if (account) {
                addConnectEvent("background", account);
            }
            setTried(true);
        }
    }, [tried, active, activate, account]);
    return tried;
};
export default useEagerConnect;
//# sourceMappingURL=useEagerConnect.js.map